import { FC, useCallback } from "react";
import { Button, Tooltip } from "@mui/material";
import AvTimerIcon from "@mui/icons-material/AvTimer";
import { useSearchParams } from "react-router-dom";
import { useAppAbility } from "../../../../../../services/permissions";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { currentAccountWorkflowDataSelector } from "../../../../../../store/account/selectors/current-account/currentAccountWorkflowDataSelector";
import { useCreateWorkflow } from "../../../utils/hooks/useCreateWorkflow.hook";
import { setWorkflowCreationDrawerOpen } from "../../../../../../store/schedules/schedulesSlice";
import { resourceTypeSearchParams } from "../../navigation/utils/constants";

export const CreateWorkflowButton: FC = () => {
  const dispatch = useAppDispatch();
  const { cannot } = useAppAbility();
  const canNotCreateSchedule = cannot("create", "schedule");

  const [searchParams] = useSearchParams();
  const resourceType = searchParams.get(resourceTypeSearchParams);

  const currentAccountWorkflowData = useAppSelector((state) =>
    currentAccountWorkflowDataSelector(state, resourceType),
  );

  const createWorkflow = useCreateWorkflow(currentAccountWorkflowData);

  const createHandler = useCallback(() => {
    createWorkflow();
    dispatch(setWorkflowCreationDrawerOpen(true));
  }, [dispatch, createWorkflow]);

  return (
    <Tooltip title="Create Workflow" arrow placement="top">
      <Button
        onClick={createHandler}
        variant="outlined"
        color="primary"
        disabled={canNotCreateSchedule}
        sx={buttonSx}
      >
        <AvTimerIcon
          fontSize="small"
          sx={{
            color: "primary.main",
          }}
        />
      </Button>
    </Tooltip>
  );
};
const buttonSx = {
  minWidth: 36,
  minHeight: 36,
  px: 0.5,
};
